import { HsVector3 } from '../../math-new/objects/vector3.class';

export namespace HsHypersceneEngineConstants {
  /**
   * Handles aspect 16 9.
   */
  export const ASPECT_16_9: number = 16 / 9;

  /**
   * Handles near plane.
   */
  export const NEAR_PLANE: number = 0.001;

  /**
   * Handles far plane.
   */
  export const FAR_PLANE: number = 20000;
  export const UP: HsVector3 = HsVector3.makeUnitVectorY();
}
